export const ADMIN_DEVICE_POLL_MS = 30_000
export const ADMIN_COMMANDS_POLL_MS = 10_000
export const ADMIN_CAPTURES_POLL_MS = 30_000
export const ADMIN_SUBMISSION_LOG_POLL_MS = 10_000
